var path = 'areas/certificates/select/certificate_select.html';
var html = "<div class=form-control> <a href=javascript:; ng-click=vm.select()><img src=" + require("../../../img/variables/certificate.png") + " height=16 width=16 alt=Certificate title=Certificate ng-show=vm.selected /> {{vm.displayText()}}</a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/select/certificate_select.html
// module id = 635116045145991
// module chunks = 1